import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import BaseButton from "@material-ui/core/Button";

const sizes = {
  small: 0.5,
  medium: 1,
  large: 1,
};

const paddings = {
  small: 0.25,
  medium: 0.75,
  large: 1.25,
};

const useStyles = makeStyles({
  root: {
    borderRadius: ({ size = "medium" }) => sizes[size] * 14,
    padding: ({ size = "medium" }) => paddings[size] * 12,
  },
  label: {
    textTransform: "initial",
    whiteSpace: "nowrap",
  },
});

const StyledButton = (props) => {
  const classes = useStyles(props);

  return <BaseButton {...props} classes={classes} />;
};

export default StyledButton;
